import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'trigger'
        }
    }

    init() {

        this.isAvailable = true;
        this.closeBind = (e) => {
            if(html.classList.contains('has-nav-open')) {
                if(e.code == 'Escape') {
                    this.close();
                }
            }
       }        
       window.addEventListener('keydown',this.closeBind);
    }

    close() {
        if(this.isAvailable) {
            this.isAvailable = false;
            html.classList.remove('has-nav-open');
            this.call('close','Nav');

            gsap.delayedCall(1,() => {
                this.isAvailable = true;
            });
        }
            
    }

    open() {
        if(this.isAvailable) {
            this.isAvailable = false;
            html.classList.add('has-nav-open');

            gsap.delayedCall(1,() => {
                this.isAvailable = true;
            });
        }
    }


    trigger() {
        if(html.classList.contains('has-nav-open')) {
            this.close();
        } else {
            this.open();
        }
    }

    destroy() {
        window.removeEventListener('keydown',this.closeBind);
    }
}
